import { getDomainURL } from "../shared/utility";
import { encryptPassword } from "../shared/requestCrypto";

export function dehydrateCheckingEmail(email) {
  return {
    domainUrl: getDomainURL() ?? "",
    userName: email,
  }
}

export async function dehydrateRegisterUser(params) {
  let formData = new FormData();
  formData.append('FirstName', params.FNAME);
  formData.append('LastName', params.LNAME);
  formData.append('Password', await encryptPassword(params.UPASSWORD));
  formData.append('UserName', params.UserName);
  formData.append('DomainUrl', getDomainURL() ?? "");

  return formData;
}